import React, { Component } from "react";
import Slider from "react-slick";
import GalleryCarouselItem from '/components/galleryCarouselItem';
import { withStyles } from '@material-ui/core/styles';
import { createGlobalStyle } from "styled-components";

const CarouselStyleComponent = createGlobalStyle`
#galleryCarouselWrapper .slick-initialized{
    padding-bottom: 40px;
}
#galleryCarouselWrapper .slick-next, #galleryCarouselWrapper .slick-prev{
    bottom: 0!important;
    top: initial;
    z-index: 1;
}
#galleryCarouselWrapper .slick-next{
    right: 16px;
}
#galleryCarouselWrapper .slick-prev{
    left: 16px;
}
@font-face {
    font-family:"DuwunFont";
    src:url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.woff2") format("woff2"),
        url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.woff") format("woff"),
        url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.ttf") format('truetype');
    font-display: swap;
  }
#scrollbarStyle::-webkit-scrollbar{
    width: 10px;
}
#scrollbarStyle::-webkit-scrollbar-track {
    background: #212121;
}

#scrollbarStyle::-webkit-scrollbar-thumb {
    background: #888;
}

#scrollbarStyle::-webkit-scrollbar-thumb:hover {
    background: #555;
}
`
const styles = (theme) => ({
    wrapper: {
        // padding: '14px 30px 0px', 
        position: 'relative',
        background: '#212121',
        border: '1px solid #363636',
        [theme.breakpoints.only('xs')]: {
            // padding: '14px 0px'
        }
    }
})

class GalleryCarousel extends Component {
  state = {
    activeSlide: 1,
  };
  render() {
    const { classes, items, active } = this.props;
    const currentTotal = `${this.state.activeSlide} / ${items && items.length}`
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (current, next) => this.setState({ activeSlide: next + 1 }),
    };
    return (
        items && items.length > 0 ? 
        <div style={{ maxWidth: 460, margin: '0 auto'}}>
            <CarouselStyleComponent />
            <div className={classes.wrapper} id='galleryCarouselWrapper'>
                <Slider {...settings}>
                    {items.map((item, index) => 
                        <React.Fragment key={index}>
                            <GalleryCarouselItem item={item} items={items} index={index} active={active} />
                        </React.Fragment>
                    ) }
                </Slider>
                <p style={{ textAlign: 'center', color: '#fff', position: 'absolute', bottom: '-5px', left: 0, right: 0}}>{currentTotal}</p>
            </div>
        </div>
    : null
    );
  }
}
export default withStyles(styles)(GalleryCarousel);